import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PrimaryTable from '../../helpers/primary-table'
import ReactLoading from 'react-loading';
import { catchError } from '../../helpers/catch-error'
import { getStatus } from '../../helpers/common'
import { CSVLink } from "react-csv";



const WorkOrdersFacility = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [woSearch, setWoSearch] = useState(false);
    const [workOrders, setWorkOrders] = React.useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [facility, setFacility] = useState(null);

    const [csvData, setCsvData] = React.useState(null);
    const [csvHeader, setCsvHeader] = React.useState([
        { label: "CASE DATE", key: "wo_creation_date" },
        { label: "PATIENT NAME", key: "patient_name" },
        { label: "DOB", key: "patient_dob_formatted" },
        { label: "MED REC NUMBER", key: "patient_med_rec_num" },
        { label: "SSN", key: "patient_ssn" },
        { label: "CURRENT STATUS", key: "status" },

    ]);

    var columns = React.useMemo(
        () => [
            {
                accessorFn: row => <a href={"/admin/work-order/" + row.work_order_id} className="btn btn-link" >{row.work_order_no}</a>,
                id: "work_order_id",
                cell: info => info.getValue(),
                header: () => "ORDER #",
            },
            {
                accessorFn: row => row.wo_creation_date_days > 14 ? row.wo_creation_date + "_ 2 Weeks+" : row.wo_creation_date + "_" + row.wo_creation_date_days + " day(s)",
                id: "wo_creation_date",
                cell: ({ getValue }) => (
                    <span>
                        <ul className="table-ul">
                            {(getValue().split("_")).map((p, index) => (
                                <li key={index}>{p}</li>
                            ))}
                        </ul>
                    </span>
                ),
                header: () => "Date",
                footer: props => props.column.id
            },
            {
                accessorFn: row => row.patient_last_name + ", " + row.patient_first_name,
                id: "patient",
                cell: info => info.getValue(),
                header: () => "PATIENT",
                footer: props => props.column.id
            },
            {
                accessorKey: "wo_order_type",
                header: "ORDER TYPE",
                footer: props => props.column.id
            },
            {
                accessorKey: "client_company_name",
                header: "CREATED BY",
                footer: props => props.column.id
            },
            {
                accessorFn: row => getStatus(row.status),
                id: "status",
                cell: info => info.getValue(),
                header: () => "STATUS",
                footer: props => props.column.id
            }
        ],
        []
    )

    useEffect(() => {

        if (params.facility_id > 0)
            getFacility(params.facility_id);

    }, []);



    const getFacility = async (facility_id) => {
        setIsLoading(true);
        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facility-by-id/" + facility_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setFacility(response?.data?.facility);


            } else {

                Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

            }
            setIsLoading(false);
        }).catch(function (error) {

            catchError(error, navigate)
        });

    }




    const searchWorkOrders = () => {

        setIsLoading(true);
        if (!facility?.facility_id) {
            setIsLoading(false);
            Swal.fire({ icon: "error", title: "Facility", text: "No facility selected" });
            return false;

        }
        var search_elements = {}

        search_elements.facility_id = facility?.facility_id;
        search_elements.start_date = woSearch?.start_date;
        search_elements.end_date = woSearch?.end_date;
        search_elements.report_type = woSearch?.report_type;
        search_elements.status = woSearch?.status;


        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-report-work-orders-facility", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setWorkOrders(response?.data?.work_orders);

                setCsvData([]);

                response?.data?.work_orders?.forEach((wo) => {

                    let new_wo = {};
                    new_wo.work_order_id = wo.work_order_no;
                    new_wo.patient_name = wo.patient_last_name + ", " + wo.patient_middle_name + "" + wo.patient_first_name;
                    new_wo.wo_creation_date = wo.wo_creation_date;
                    new_wo.patient_dob_formatted = wo.patient_dob_formatted;
                    new_wo.patient_med_rec_num = wo.patient_med_rec_num;
                    new_wo.patient_ssn = wo.patient_ssn;
                    new_wo.status = getStatus(wo.status);

                    setCsvData((csvData) => [...csvData, new_wo])



                });






            }
            else {

                setWorkOrders(null);

            }
            setIsLoading(false);


        }).catch(function (error) {

            // setIsBtn(false);
            catchError(error, navigate)

        });


    }


    return (
        <>

            <div className="row pb-2 mt-4">
                <div className="col-md-12 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">WORK ORDER REPORT BY Facility:<span className="fw-bold text-danger">{facility?.facility_name}</span></h3>
                </div>


            </div>

            <div className="card card-form card-primary mt-4 pb-2">
                <div className="card-body">
                    <form className="form-horizontal form-thick mb-2"  >

                        <div className="row px-3 gx-3">

                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="invoice_date_range">START DATE</label>

                                <DatePicker name="start_date" id="start_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsStart
                                    isClearable={true}
                                    selected={woSearch?.start_date}
                                    onChange={(e) => {

                                        var dt = new Date(e);

                                        const year = dt.getFullYear();
                                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                        const day = dt.getDate().toString().padStart(2, "0");

                                        const formatted_date = month + '/' + day + '/' + year

                                        setWoSearch({ ...woSearch, start_date: formatted_date })

                                    }
                                    }

                                />
                            </div>
                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="invoice_date_range">END DATE</label>

                                <DatePicker name="end_date" id="end_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsEnd
                                    isClearable={true}
                                    selected={woSearch?.end_date}
                                    onChange={(e) => {
                                        var dt = new Date(e);

                                        const year = dt.getFullYear();
                                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                        const day = dt.getDate().toString().padStart(2, "0");

                                        const formatted_date = month + '/' + day + '/' + year

                                        setWoSearch({ ...woSearch, end_date: formatted_date })

                                    }
                                    }
                                />
                            </div>


                            `
                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="wo_order_type" >Type</label>
                                <select name="report_type" className="form-select" type="text"
                                    value={woSearch?.report_type}
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, report_type: e.target.value })
                                    }
                                >
                                    <option value=""></option>
                                    <option value="0">Work Orders</option>
                                    <option value="1">Invoices</option>
                                </select>
                            </div>
                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="status">Status</label>
                                <select name="status" className="form-select" type="text"
                                    value={woSearch?.status}
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, status: e.target.value })
                                    }
                                >
                                    <option value="" selected="">All</option>
                                    <option value="1">Open, not invoiced yet</option>
                                    <option value="4">Open, records Obtained</option>
                                    <option value="7">Closed</option>
                                </select>
                            </div>


                        </div>


                    </form>

                </div>

                <div className="card-footer">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                            <button onClick={() => searchWorkOrders()} className="btn btn-primary mx-1" type="button" disabled={isLoading ? true : false} >{isLoading ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SEARCH"} </button>
                            {csvData &&
                                <> 
                                    <a href={"/admin/report-work-orders-facility-print/" + params.facility_id + "?start_date=" + (woSearch?.start_date ? woSearch?.start_date : "") + "&end_date=" + (woSearch?.end_date ? woSearch?.end_date : "") + "&report_type=" + (woSearch?.report_type ? woSearch?.report_type : "") + "&status=" + (woSearch?.status ? woSearch?.status : "")} className="btn btn-success mx-1" type="button">PDF</a>
                                    <CSVLink data={csvData} headers={csvHeader} className="btn btn-warning mx-1" >CSV</CSVLink>
                                </>

                            }
                              <button onClick={() => { setWorkOrders(null) }} className="btn btn-danger mx-1" type="button">CLEAR SEARCH </button>
                          
                        </div>

                    </div>
                </div>
            </div>




            {(workOrders || isLoading) &&

                <div className="card card-form card-primary mt-4 " >
                    <div className="card-body p-0 mb-0" >

                        {isLoading ?
                            <div className="loader">
                                <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
                            </div>
                            :
                            <PrimaryTable columns={columns} data={workOrders} />
                        }


                    </div>
                </div>

            }


        </>


    );
};

export default WorkOrdersFacility;